const BASE = 'https://qbdp-backend-production.up.railway.app/api';
function getToken() {
  return sessionStorage.getItem('qbdp_token');
}
async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`,
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur serveur');
  return data;
}
export const api = {
  login:          (email, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  me:             () => request('/auth/me'),
  getEmployes:    () => request('/employes'),
  addEmploye:     (data) => request('/employes', { method: 'POST', body: JSON.stringify(data) }),
  updateEmploye:  (id, data) => request(`/employes/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteEmploye:  (id) => request(`/employes/${id}`, { method: 'DELETE' }),
  getAbsences:     (id) => request(`/employes/${id}/absences`),
  getAllAbsences:   () => request('/employes/absences/toutes'),
  addAbsence:      (id, data) => request(`/employes/${id}/absences`, { method: 'POST', body: JSON.stringify(data) }),
  deleteAbsence:   (empId, absId) => request(`/employes/${empId}/absences/${absId}`, { method: 'DELETE' }),
  assistant:       (data) => request('/ai/assistant', { method: 'POST', body: JSON.stringify(data) }),
  envoyerEmail:    (data) => request('/ai/envoyer-email', { method: 'POST', body: JSON.stringify(data) }),
  envoyerSms:      (data) => request('/ai/envoyer-sms',  { method: 'POST', body: JSON.stringify(data) }),
  envoyerPush:     (data) => request('/ai/envoyer-push', { method: 'POST', body: JSON.stringify(data) }),
  getVeille:       () => request('/employes/pointage/veille'),
  getPointage:     (id, mois) => request(`/employes/${id}/pointage?mois=${mois}`),
  upsertPointage:  (id, data) => request(`/employes/${id}/pointage`, { method: 'POST', body: JSON.stringify(data) }),
  deletePointage:  (id, date) => request(`/employes/${id}/pointage/${date}`, { method: 'DELETE' }),
  getBatiments:   () => request('/batiments'),
  addBatiment:    (data) => request('/batiments', { method: 'POST', body: JSON.stringify(data) }),
  updateBatiment: (id, data) => request(`/batiments/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteBatiment: (id) => request(`/batiments/${id}`, { method: 'DELETE' }),
  addEtage:       (batId, data) => request(`/batiments/${batId}/etages`, { method: 'POST', body: JSON.stringify(data) }),
  updateEtage:    (batId, etageId, data) => request(`/batiments/${batId}/etages/${etageId}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteEtage:    (batId, etageId) => request(`/batiments/${batId}/etages/${etageId}`, { method: 'DELETE' }),
  addPorte:       (batId, data) => request(`/batiments/${batId}/portes`, { method: 'POST', body: JSON.stringify(data) }),
  updatePorte:    (batId, porteId, data) => request(`/batiments/${batId}/portes/${porteId}`, { method: 'PUT', body: JSON.stringify(data) }),
  deletePorte:    (batId, porteId) => request(`/batiments/${batId}/portes/${porteId}`, { method: 'DELETE' }),
  getLogs:        (params = {}) => request('/logs?' + new URLSearchParams(params)),
  getStats:       () => request('/logs/stats'),
  getServices:    () => request('/services'),
  addService:     (nom) => request('/services', { method: 'POST', body: JSON.stringify({ nom }) }),
  updateService:  (id, nom) => request(`/services/${id}`, { method: 'PUT', body: JSON.stringify({ nom }) }),
  deleteService:  (id) => request(`/services/${id}`, { method: 'DELETE' }),
  getClients:         () => request('/clients'),
  createClient:       (data) => request('/clients', { method: 'POST', body: JSON.stringify(data) }),
  updateClient:       (id, data) => request(`/clients/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  updateClientStatut: (id, statut) => request(`/clients/${id}/statut`, { method: 'PATCH', body: JSON.stringify({ statut }) }),
  deleteClient:       (id) => request(`/clients/${id}`, { method: 'DELETE' }),
  request:        (path, options = {}) => request(path, options),
};
